import { Flex } from 'foundations-components/components/Flex';
import { SortDropdown } from '../../search-results/components/SortDropdown';
import { FilterPanelButton } from './FilterPanelButton';
import { FilterTags } from './FilterTags';
import { UniversalFilterControls } from './UniversalFilterControls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function StorefrontFilterBar() {
  return /*#__PURE__*/_jsxs(Flex, {
    "data-test-id": "storefront-filter-bar",
    flexDirection: "column",
    gap: "600",
    marginBlockStart: "600",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "start",
      backgroundColor: "fill-surface-default",
      borderColor: "border-primary-subtle",
      borderRadius: "200",
      borderStyle: "solid",
      borderWidth: "100",
      justifyContent: "space-between",
      padding: "400",
      children: [/*#__PURE__*/_jsx(UniversalFilterControls, {}), /*#__PURE__*/_jsx(FilterPanelButton, {})]
    }), /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      alignItems: "start",
      marginBlockEnd: "600",
      children: [/*#__PURE__*/_jsx(FilterTags, {}), /*#__PURE__*/_jsx(SortDropdown, {})]
    })]
  });
}